export interface SkinBackground {
    type: 'smart' | 'siesa'
    value: string  
}

export interface SkinConfig {
    rootClass: string
	name: string
    iconPath: string
    principalColor: string
	logoFileName: string
	logoHeight: string
	logoMaxWidth: string
    logoNavBarHeight: string
    backgroundNavbarColor:string
    profileTextColor:string
    pageTransitionClass:string
    background: SkinBackground
}

export const skins: Record<string, SkinConfig> = {
    smart: {
        rootClass: 'skin_smart',
        name: ' | SmartAccess',
        iconPath: '/assets/images/SmartAccess_Ico.ico',
        principalColor : '#F6661E',
        logoFileName: 'logo-light',
        logoHeight: '28px',
        logoMaxWidth: '100%',
        logoNavBarHeight: '16px',
        backgroundNavbarColor: '#f3a87ab6',
        profileTextColor: 'text-light',
        pageTransitionClass: 'transition_smart',
        background: {
        type: 'smart',
        value: 'auth-particles',
        },
    },
    siesa: {
        rootClass: 'skin_siesa',
        name: ' | SiesaAccess',
        iconPath: '/assets/images/favicon-siesa.ico',
        principalColor : '#2d71ea',
        logoFileName: 'siesa-light',
        logoHeight: '55px',
        logoMaxWidth: '',
        logoNavBarHeight: '30px',
        backgroundNavbarColor: 'rgba(255,255,255,0.8)',
        profileTextColor: 'skinSiesa',
        pageTransitionClass: 'transition_siesa',
        background: {
        type: 'siesa',
        value: 'siesa-wave',
        },
    },
    human: {
        rootClass: 'skin_siesa', 
        name: ' | HumanAccess',
        iconPath: '/assets/images/HumanACcess_ico.ico',
        principalColor : '#2d71ea',
        logoFileName: 'logo-human-access',
        logoHeight: '150px',
        logoMaxWidth: '',
        logoNavBarHeight: '70px',
        backgroundNavbarColor: 'rgba(255,255,255,0.8)',
        profileTextColor: 'skinSiesa',
        pageTransitionClass: 'transition_siesa',
        background: {
        type: 'siesa',
        value: 'siesa-wave',
        },
    },
}